export default {"src":"/_next/static/media/instagram-icon.0b70c878.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};